import { apiClient } from '@/api/axios';

export interface ApiNotification {
  id: string;
  userClerkId: string;
  platform: string;
  type: string;
  title: string;
  message: string;
  read: boolean;
  petId?: string;
  petName?: string;
  actionRequired?: boolean;
  actionLink?: string;
  icon?: string;
  professionalName?: string;
  recordType?: string;
  proposalId?: string;
  metadata?: Record<string, unknown>;
  createdAt: string;
}

export const notificationsApi = {
  async list(params?: Record<string, any>) {
    const { data } = await apiClient.get<{ items: ApiNotification[]; total: number; unreadCount: number }>('/notifications', { params });
    return data;
  },

  async create(body: Partial<ApiNotification>) {
    const { data } = await apiClient.post<ApiNotification>('/notifications', body);
    return data;
  },

  async markRead(id: string) {
    await apiClient.patch(`/notifications/${id}/read`);
  },

  async markAllRead() {
    await apiClient.patch('/notifications/read-all');
  },

  async remove(id: string) {
    await apiClient.delete(`/notifications/${id}`);
  },

  async clearAll() {
    await apiClient.delete('/notifications');
  },
};
